import React from "react";
import { t } from "../../../components/CustomComponent.js";
import ICON from "../icons.js";
import { DOC_SLOTS, DOC_TYPES, EXPERIENCE_OPTIONS, EXPERTISE_OPTIONS } from "../partner_option.js";
import { bankLabel } from "../../../components/topup_option.js";
import "../../../components/global.js";

/* ชื่อธนาคารมีสองภาษาใน global.bank — ตามภาษาที่ผู้ใช้ตั้งไว้ เหมือนช่องกรอกในขั้นที่ 1 */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";

/* ============================================================================
 * PartnerTerms — ขั้นที่ 3 : ตรวจทานข้อมูล + ยอมรับข้อกำหนด
 *
 * ก่อนกดส่งต้องได้เห็นทุกอย่างที่กรอกมาในหน้าเดียว เพราะส่งแล้วแก้เองไม่ได้
 * ต้องรอผู้ดูแลตีกลับ — ทุกบล็อกจึงมีปุ่ม "แก้ไข" พากลับไปยังขั้นที่กรอกไว้
 *
 * แยกความยินยอมเป็น 2 ข้อโดยตั้งใจ :
 *   - ข้อกำหนดการเป็นพาร์ตเนอร์ = ข้อตกลงทางธุรกิจ (ค่าคอมมิชชั่น จรรยาบรรณ)
 *   - ความยินยอมข้อมูลส่วนบุคคล = ฐานทางกฎหมายในการเก็บสำเนาบัตร (PDPA)
 * รวมเป็นติ๊กเดียวไม่ได้ เพราะเป็นการยินยอมคนละเรื่องกัน
 * ========================================================================== */

/** ป้ายชื่อของค่าที่เลือกจากรายการคงที่ — ไม่เจอก็คืนค่าว่างแทนที่จะโชว์รหัสดิบ */
const optionLabel = (options, value) => {
  const found = options.find((item) => item.value === value);
  return found ? t(found.label) : "";
};

/* หัวข้อย่อยของข้อกำหนด — เป็นสรุปสั้นให้อ่านจบในกล่อง ฉบับเต็มอยู่ที่ /terms-of-use
   TODO(api) : ดึงจาก "จัดการหน้าแรก › ข้อกำหนด" เมื่อเพิ่มเอกสารฉบับพาร์ตเนอร์แล้ว */
const TERMS_POINTS = [
  "partner_terms_point_1",
  "partner_terms_point_2",
  "partner_terms_point_3",
  "partner_terms_point_4",
  "partner_terms_point_5",
];

export default function PartnerTerms({ form, errors = {}, onChange, onEdit }) {
  const address = [form.address, form.subdistrict, form.district, form.province, form.postcode]
    .filter((part) => !!String(part || "").trim())
    .join(" ");

  const expertise = (form.expertise || []).map((value) => optionLabel(EXPERTISE_OPTIONS, value)).filter(Boolean);
  const attached = (DOC_SLOTS[form.doc_type] || []).filter((slot) => (form.docs || {})[slot.key]);

  const row = (label, value) => (
    <div className="hm-pt-sum__row">
      <span className="hm-pt-sum__label">{label}</span>
      <span className="hm-pt-sum__value">{value || <em className="hm-muted">{t("partner_not_filled")}</em>}</span>
    </div>
  );

  return (
    <>
      <div className="hm-pt-block__title">{t("partner_section_review")}</div>

      <div className="hm-pt-sum">
        <div className="hm-pt-sum__head">
          <span>{t("partner_section_personal")}</span>
          <button type="button" className="hm-pt-link" onClick={() => onEdit("profile")}>
            <span className="hm-ico">{ICON.file}</span>
            {t("partner_review_edit")}
          </button>
        </div>
        {/* รูปโปรไฟล์ขึ้นก่อนชื่อ เพราะเป็นสิ่งเดียวในใบที่ต้อง "ดู" ว่าถูกใบไหม ไม่ใช่อ่าน */}
        {row(
          t("partner_picture"),
          form.picture?.url ? <img src={form.picture.url} alt="" className="hm-pt-sum__avatar" /> : ""
        )}
        {row(t("partner_name"), form.name)}
        {row(
          t("partner_email"),
          <>
            {form.email}
            {form.email_verified && (
              <span className="hm-pt-tag">
                <span className="hm-ico">{ICON.check}</span>
                {t("partner_otp_verified_short")}
              </span>
            )}
          </>
        )}
        {row(t("partner_phone"), form.phone)}
        {row(t("partner_line"), form.line_id)}
        {row(t("partner_address"), address)}
        {row(t("partner_experience_level"), optionLabel(EXPERIENCE_OPTIONS, form.experience))}
        {row(t("partner_license"), form.license)}
        {row(t("partner_expertise"), expertise.join(" · "))}
        {row(t("partner_about"), form.about)}
      </div>

      {/* บัญชีรับเงินแยกกล่องของตัวเอง ไม่รวมกับข้อมูลส่วนตัว — เป็นข้อมูลที่กรอกผิด
          แล้วเสียหายเป็นตัวเงิน คนตรวจทานควรเห็นมันเป็นก้อนเดี่ยว ๆ ไม่ใช่บรรทัดหนึ่ง
          ที่ไหลไปกับที่อยู่และความถนัด (ปุ่มแก้ไขพากลับไปขั้นเดียวกันคือขั้นที่ 1) */}
      <div className="hm-pt-sum">
        <div className="hm-pt-sum__head">
          <span>{t("partner_section_bank")}</span>
          <button type="button" className="hm-pt-link" onClick={() => onEdit("profile")}>
            <span className="hm-ico">{ICON.file}</span>
            {t("partner_review_edit")}
          </button>
        </div>
        {row(t("partner_bank"), form.bank ? bankLabel(form.bank, isTh()) : "")}
        {row(t("partner_account_no"), form.bank_account_no)}
        {row(t("partner_account_name"), form.bank_account_name)}
      </div>

      <div className="hm-pt-sum">
        <div className="hm-pt-sum__head">
          <span>{t("partner_section_doc")}</span>
          <button type="button" className="hm-pt-link" onClick={() => onEdit("verify")}>
            <span className="hm-ico">{ICON.file}</span>
            {t("partner_review_edit")}
          </button>
        </div>
        {row(t("partner_doc_type"), optionLabel(DOC_TYPES, form.doc_type))}
        {row(
          t("partner_doc_attached"),
          <span className="hm-pt-sum__files">
            {attached.map((slot) => (
              <span key={slot.key} className="hm-pt-tag">
                <span className="hm-ico">{ICON.check}</span>
                {t(slot.label)}
              </span>
            ))}
          </span>
        )}
      </div>

      <div className="hm-pt-block__title">{t("partner_section_terms")}</div>

      {/* กางให้เห็นครบทั้งก้อน ไม่ใช่ลิงก์อย่างเดียว — ผู้สมัครส่วนใหญ่ไม่กดออกไปอ่าน
          หน้าอื่นแล้วกลับมา สรุปข้อสำคัญไว้ตรงนี้จึงมีคนอ่านจริงมากกว่า */}
      <div className="hm-pt-terms">
        <b>{t("partner_terms_heading")}</b>
        <ul>
          {TERMS_POINTS.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>
        <a href="/terms-of-use" target="_blank" rel="noreferrer">
          {t("partner_terms_full")}
          <span className="hm-ico">{ICON.external}</span>
        </a>
      </div>

      <label className={`hm-pt-check ${errors.accept_terms ? "is-error" : ""}`}>
        <input
          type="checkbox"
          checked={form.accept_terms}
          onChange={(e) => onChange({ accept_terms: e.target.checked })}
        />
        <span>
          {t("partner_terms_accept")}{" "}
          <a href="/terms-of-use" target="_blank" rel="noreferrer">
            {t("partner_terms_link")}
          </a>
        </span>
      </label>
      {!!errors.accept_terms && <span className="hm-pt-field__error">{t(errors.accept_terms)}</span>}

      <label className={`hm-pt-check ${errors.accept_pdpa ? "is-error" : ""}`}>
        <input
          type="checkbox"
          checked={form.accept_pdpa}
          onChange={(e) => onChange({ accept_pdpa: e.target.checked })}
        />
        <span>
          {t("partner_pdpa_accept")}{" "}
          <a href="/policy-privacy" target="_blank" rel="noreferrer">
            {t("partner_pdpa_link")}
          </a>
        </span>
      </label>
      {!!errors.accept_pdpa && <span className="hm-pt-field__error">{t(errors.accept_pdpa)}</span>}
    </>
  );
}
